import React from 'react'

const AddOrderModal = ({handleAddDataSubmit,handleChange, formRef}) => {
  return (
    <>
       <div
        className="modal custom-modal fade"
        id="exampleModal"
        tabIndex="-1"
        role="dialog"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div class="modal-dialog modal-lg">
          <div class="modal-content">
            <div class="modal-header">
              {/* <h5 class="modal-title" id="imageZoomModalTitle">Galeria</h5> */}
              <button
                type="button"
                class="custon-close-button-color close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
              <div className="col-12 grid-margin">
                <div className="card">
                  <div className="card-body">
                    <h4 className="card-title">Add Company</h4>
                    <form className="form-sample" ref={formRef}>
                      {/* <p className="card-description">Personal info</p> */}
                      <div className="row">
                        <div className="col-md-3">
                          <div className="form-group">
                            <label htmlFor="Location">Location</label>

                            <input
                              type="text"
                              className="form-control"
                              name="location"
                              id="Location"
                              placeholder="Location"
                              onChange={handleChange}
                            />
                          </div>
                        </div>
                        <div className="col-md-3">
                          <div className="form-group">
                            <label htmlFor="alloted">Alloted</label>
                            <input
                              type="text"
                              className="form-control"
                              name="alloted"
                              id="alloted"
                              placeholder="Alloted"
                              onChange={handleChange}
                            />
                          </div>
                        </div>
                        <div className="col-md-3">
                          <div className="form-group">
                            <label htmlFor="rca_no">Rca No</label>
                            <input
                              type="text"
                              className="form-control"
                              name="rca_no"
                              id="rca_no"
                              placeholder="Rca No"
                              onChange={handleChange}
                            />
                          </div>
                        </div>
                        <div className="col-md-3">
                          <div className="form-group">
                            <label htmlFor="Size">Size</label>
                            <input
                              type="text"
                              className="form-control"
                              name="size"
                              id="size"
                              placeholder="Size"
                              onChange={handleChange}
                            />
                          </div>
                        </div>
                      </div>
                      <button
                        className="btn btn-primary mr-2 mt-3"
                        type="submit"
                        onClick={handleAddDataSubmit}
                      >
                        Save
                      </button>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default AddOrderModal